import { registerNavigationListener } from "../navigationBroker";
import topFrameNavigationMessenger from "./topFrameNavigationMessenger";

const iframedSiteNavigationListener = () => {
  if (window.top !== window) {
    window.addEventListener("beforeunload", () => {
      topFrameNavigationMessenger({
        type: "site-chrome-navigation-beforeunload-event",
        href: window.location.href
      });
    });

    window.addEventListener("load", () => {
      topFrameNavigationMessenger({
        type: "site-chrome-navigation-load-event",
        href: window.location.href
      });
    });

    registerNavigationListener(event => {
      const { href } = event.detail;
      topFrameNavigationMessenger({
        type: "site-chrome-navigation-broker-event",
        href
      });
    });
  }
};

export default iframedSiteNavigationListener;
